import { AllDimensionListPayload, ModelledListPayload } from './dimensions'
import { scopeTypes } from './ScopeNames'

export const getNavbarCountKey = {
  keys: (
    scope: scopeTypes,
    countParam: {
      id: number
      startDate: number
      endDate: number
    }
  ) => [{ scope, countParam } as const],
}

export const getIODetailKey = {
  keys: (
    scope: scopeTypes,
    ioParam: {
      id: number
    }
  ) => [{ scope, ioParam } as const],
}

export const getCampaignDetailKey = {
  keys: (scope: scopeTypes, id: number) => [{ scope, id } as const],
}

export const getIOBudgetDistributionMethodKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getCountriesListKey = {
  keys: (scope: scopeTypes, segmentIds: number[]) => [
    { scope, segmentIds } as const,
  ],
}

export const getStatesListKey = {
  keys: (scope: scopeTypes, segmentIds: number[]) => [
    { scope, segmentIds } as const,
  ],
}

export const getConversionsInfoKey = {
  keys: (scope: scopeTypes, conversionIds: string) => [
    { scope, conversionIds } as const,
  ],
}

export const getCampaignAttachedCreativesInfoKey = {
  keys: (
    scope: scopeTypes,
    creativesParam: {
      campaignId: number
    }
  ) => [{ scope, creativesParam } as const],
}

export const getAudiencesListKey = {
  keys: (
    scope: scopeTypes,
    audienceListParam: {
      audienceTypeIds: string
      owIds: string
    }
  ) => [{ scope, audienceListParam } as const],
}

export const getCustomerConfigKey = {
  keys: (scope: scopeTypes, customerOwId: string) => [
    { scope, customerOwId } as const,
  ],
}

export const getModelledDimensionsCountKey = {
  keys: (scope: scopeTypes, campaignId: number, dimensionId?: number) => [
    { scope, campaignId, dimensionId } as const,
  ],
}

export const getInventoryGroupDetailsKey = {
  keys: (
    scope: scopeTypes,
    inventoryGroupParam: {
      groupIds: string
      pageNo: number
      includeContextualCount: boolean
    }
  ) => [{ scope, inventoryGroupParam } as const],
}

export const getAdCategoriesKey = {
  keys: (scope: scopeTypes, publisherCategoryIds: number[]) => [
    { scope, publisherCategoryIds } as const,
  ],
}

export const getPreBidSegmentsKey = {
  keys: (scope: scopeTypes, prebidAudienceSegmentIdList: number[]) => [
    { scope, prebidAudienceSegmentIdList } as const,
  ],
}

export const getPrebidProviderDetailsKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getTrafficTypesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getManufacturersKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getOsTypesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getNetworkTypesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getDeviceTypesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getCarriersKey = {
  keys: (scope: scopeTypes, carriers: string) => [{ scope, carriers } as const],
}

export const getAllDimensionListKey = {
  keys: (args: AllDimensionListPayload & { scope: scopeTypes }) => [args],
}

export const getModelledDimensionListKey = {
  keys: (args: ModelledListPayload & { scope: scopeTypes }) => [args],
}

export const getListKey = {
  keys: (args: {
    scope: scopeTypes
    searchField?: string
    campaignId: string
    endDate: string
    startDate: string
    noOfEntries: number
    order?: string // 'DESC' | 'ASC'
    sortBy?: string
    timeZoneId: number
    pageSize?: number
    pageNo?: number
    isExcluded?: 0 | 1
    dimensionId: number
  }) => [args],
}

export const getAgesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getEthnicitiesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getIncomesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getInterestsKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getLanguagesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getExchangesKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getGenderKey = {
  keys: (scope: scopeTypes) => [{ scope } as const],
}

export const getPoliticalAdvertiserInfoKey = {
  keys: (scope: scopeTypes, politicalAdvertiserId: string) => [
    { scope, politicalAdvertiserId } as const,
  ],
}

export const getCreativeInfoKey = {
  keys: (scope: scopeTypes, creativeId: number) => [
    { scope, creativeId } as const,
  ],
}
